import React from 'react';
import { motion } from 'framer-motion';
import { XCircle, CheckCircle2, ArrowDown } from 'lucide-react';
export function Transformation() {
  return <section className="py-24 bg-ed-darker relative overflow-hidden" data-id="element-493">
      <div className="absolute inset-0 bg-radial-green-center opacity-30 pointer-events-none" data-id="element-494"></div>

      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-495">
        <div className="text-center mb-16" data-id="element-496">
          <h2 className="text-4xl sm:text-5xl font-black uppercase tracking-tight text-white leading-tight" data-id="element-497">
            No es solo aprender electricidad. <br data-id="element-498" />
            <span className="text-ed-green" data-id="element-499">
              Es convertirte en profesional.
            </span>
          </h2>
        </div>

        <div className="grid md:grid-cols-[1fr_auto_1fr] gap-8 md:gap-4 items-stretch" data-id="element-500">
          {/* Before */}
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-ed-dark border border-zinc-800 rounded-2xl p-8 flex flex-col justify-center grayscale-[50%]" data-id="element-501">
            <h3 className="text-xl font-black text-zinc-500 uppercase tracking-wider mb-8 border-b border-zinc-800 pb-4" data-id="element-502">
              Antes
            </h3>
            <ul className="space-y-6" data-id="element-503">
              {['No sabés por dónde empezar', 'Dependés de un sueldo fijo', 'Tenés inseguridad técnica', 'No entendés instalaciones reales'].map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-504">
                  <XCircle className="w-6 h-6 text-red-500/70 shrink-0 mt-0.5" data-id="element-505" />
                  <span className="text-zinc-400 font-medium" data-id="element-506">{item}</span>
                </li>)}
            </ul>
          </motion.div>

          {/* Divider */}
          <div className="flex justify-center items-center py-4 md:py-0" data-id="element-507">
            <div className="w-12 h-12 rounded-full bg-ed-black border border-zinc-800 flex items-center justify-center z-10 shadow-xl" data-id="element-508">
              <ArrowDown className="w-6 h-6 text-zinc-500 md:-rotate-90" data-id="element-509" />
            </div>
          </div>

          {/* After */}
          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-ed-black border border-ed-green/30 rounded-2xl p-8 flex flex-col justify-center relative overflow-hidden group" data-id="element-510">
            <div className="absolute inset-0 bg-ed-green/5 group-hover:bg-ed-green/10 transition-colors" data-id="element-511"></div>
            <div className="relative z-10" data-id="element-512">
              <h3 className="text-xl font-black text-ed-green uppercase tracking-wider mb-8 border-b border-ed-green/20 pb-4" data-id="element-513">
                Después
              </h3>
              <ul className="space-y-6" data-id="element-514">
                {['Entendés instalaciones domiciliarias', 'Trabajás con criterio profesional', 'Ganás confianza técnica', 'Aprendés normativa y buenas prácticas', 'Podés generar ingresos reales'].map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-515">
                    <CheckCircle2 className="w-6 h-6 text-ed-green shrink-0 mt-0.5" data-id="element-516" />
                    <span className="text-white font-medium" data-id="element-517">{item}</span>
                  </li>)}
              </ul>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}